import React from "react";
import { FaAngleDown, FaAngleUp } from "react-icons/fa";
import { IoShareSocialOutline } from "react-icons/io5";

const SharedListDetails = ({
  li,
  handleSharedToggle,
  openSharedListId,
  title,
  subTitle,
}) => {
  return (
    <div className="relative z-10 inline-block">
      <div
        className={`flex items-center justify-between gap-1 px-2 text-white rounded-md cursor-pointer ${
          li?.sharedUsers?.length > 0 && li?.owner
            ? "bg-theme-color"
            : "bg-[#504E4E]"
        }`}
        onClick={() => handleSharedToggle(li.list_id)}
      >
        <IoShareSocialOutline size={15} />
        <p className="py-1 text-sm font-bold select-none">{title}</p>
        {openSharedListId === li.list_id ? (
          <FaAngleUp size={12} />
        ) : (
          <FaAngleDown size={12} />
        )}
      </div>
      {openSharedListId === li.list_id && (
        <div className="absolute left-0  text-xs text-gray-800 bg-[#FFF6F8] border rounded-md shadow-lg whitespace-nowrap">
          <div className="px-3 py-2">
            <p className="mb-1 font-bold">{subTitle}</p>
            <hr
              className="border border-gray-500 text-theme-color"
              style={{ borderWidth: "1px" }}
            />
            {li?.sharedUsers?.length > 0 && li?.owner ? (
              li?.sharedUsers.map((user, index) => (
                <div className="my-1" key={index}>
                  <p className="font-bold text-gray-900">{user.name}</p>
                  <p>{user.email}</p>
                </div>
              ))
            ) : (
              <div className="my-1">
                <p className="font-bold text-gray-900">{li.ownerName}</p>
                <p>{li.ownerEmail}</p>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default SharedListDetails;
